// extracted by mini-css-extract-plugin
module.exports = {"loadingDiv":"styles_loadingDiv__293-0","secondaryImg":"styles_secondaryImg__1kq89"};